<div class="learnspace-theme mat-card">
  <mat-card-title>
    {{ title }}
  </mat-card-title>
  <mat-card-subtitle>
    A {{ mode | spaceLabel | titlecase }} is a collaborative project environment to be shared within a team. A {{ mode | spaceLabel | titlecase }} can include one or multiple immersive {{ mode | courseLabel:true }}. <mat-icon (click)="openHelp()"  matTooltip="Open Help Center" matTooltipShowDelay="500">help</mat-icon>
  </mat-card-subtitle>
  <form [formGroup]="lsForm" class="mat-white-bg">
      <div class="section">
        <!-- <div class="tag">
          <p>Title</p>
        </div> -->
        <mat-form-field>
          <input matInput placeholder="Title" formControlName="title" #titleInput maxlength="50">
          <mat-hint align="end">{{titleInput.value?.length || 0}}/50</mat-hint>
        </mat-form-field>
      </div>

      <div class="section">
        <!-- <div class="tag">
          <p>Description</p>
        </div> -->
        <mat-form-field>
          <textarea matInput placeholder="Description" formControlName="description"></textarea>
        </mat-form-field>
      </div>


      <div class="section">
        <h3 for="inputEmail3" class="control-label">Poster image</h3>
        <interactive-thumbnail [asset]="this.asset" [width]="'179px'" [height]="'100px'" [isMediaErrorDisplayed]="(this.asset)" (thumbnailClick)="onOpenFileManager()">
        </interactive-thumbnail>
        <p *ngIf="!this.lsForm.controls.postermedia_id.value" class="mat-caption no-poster-hint">Please select an image to continue. JPG recommended.</p>
      </div>

      <div class="buttons">
        <button mat-button color="warn" (click)="this._dialogRef.close();"> CANCEL </button>
        <button mat-raised-button color="primary" (click)="saveAndCloseDialog()" [disabled]="lsForm.invalid"> SAVE </button>
      </div>
  </form>

</div>